<template>
  <el-dialog
    :title="title || '新增发票抬头'"
    :visible.sync="dialogVisible"
    width="500px"
  >
    <el-form
      :model="form"
      label-width="120px"
      class="formPage el-viewform"
      ref="form"
    >
      <el-form-item
        v-if="showInvoiceType"
        label="发票类型"
        prop="invoiceType"
        :rules="rules.invoiceType"
        class="form-item-full"
      >
        <el-radio-group v-model="form.invoiceType" @change="handleTypeChange">
          <el-radio label="30">普票</el-radio>
          <el-radio label="20" v-if="isShowSpecialTicket">专票</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="名称"
        prop="invoiceTitle"
        :rules="rules.invoiceTitle"
        class="form-item-full"
      >
        <el-autocomplete
          popper-class="my-autocomplete"
          :disabled="disabled|| showInvoiceType"
          v-model="form.invoiceTitle"
          :fetch-suggestions="querySearch"
          placeholder="请输入单位名称"
          class="form-item-full"
          @select="handleSelect"
          clearable
        >
          <i class="el-icon-edit el-input__icon" slot="suffix" v-if="!(disabled|| showInvoiceType)"> </i>
          <template slot-scope="{ item }">
            <div class="name">{{ item.invoiceTitle }}</div>
            <span class="addr">{{ item.taxNumber }}</span>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item
        label="税号"
        prop="taxNumber"
        :rules="rules.taxNumber"
        class="form-item-full"
      >
        <el-input
          :disabled="disabled"
          v-model.trim="form.taxNumber"
          placeholder="请输入纳税人识别码"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="单位地址"
        prop="regAddress"
        :rules="type === '2' ? rules.regAddress : {}"
        class="form-item-full"
      >
        <el-input
          v-model="form.regAddress"
          placeholder="请输入单位地址"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="电话号码"
        prop="linkTel"
        :rules="type === '2' ? rules.linkTel : {}"
        class="form-item-full"
      >
        <el-input
          v-model="form.linkTel"
          placeholder="请输入电话号码"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="开户银行"
        prop="regBank"
        :rules="type === '2' ? rules.regBank : {}"
        class="form-item-full"
      >
        <el-input
          v-model="form.regBank"
          placeholder="请输入开户银行"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="银行账号"
        prop="bankNo"
        :rules="type === '2' ? rules.bankNo : {}"
        class="form-item-full"
      >
        <el-input v-model.trim="form.bankNo" placeholder="请输入银行账号"></el-input>
      </el-form-item>
      <el-form-item label="电子邮箱" prop="email" class="form-item-full"  :rules="isOtiPlat ? rules.email : {}">
        <el-input v-model="form.email" placeholder="请输入电子邮箱地址"></el-input>
      </el-form-item>
      <div style="color:#F00">
         *请在20天后登录本平台下载发票
      </div>
    
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
      <el-button type="primary" @click="saveInvoiceForm">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { pickBy, identity, isEmpty, cloneDeep } from 'lodash'
import { queryInvoice } from '@/api/order'
import {
  bidderTaxID,
  bidderMobilePhonePass,
  bidderBank,
} from '@/shared/validate'

export default {
  name: 'invoiceDialog',
  props: {
    title: String,
    disabled: Boolean,
    isOtiPlat: Boolean,
    showInvoiceType: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialogVisible(v) {
      if (v && this.showInvoiceType) {
        //查詢发票抬头信息
        queryInvoice().then((v) => {
          this.restaurants = v.data
        })
      //中汇创兴非融资性担保有限公司、中霆正非融资性担保河北有限公司、张家口四铁投标有限公司、岩烁担保、苏州建信衡顺工程担保  只支持普票
      let notSpecTickOrgIg = [18,19,24,31,33,34]
      if(notSpecTickOrgIg.includes(this.$parent.dataList.applicationChannelId)){
        this.isShowSpecialTicket = false
      }else{
        this.isShowSpecialTicket = true
      }
      } else if (!v) {
        this.$refs.form.resetFields()
        this.type = '1'
      }
    },
    form: {
      handler(v) {
        //先不要了 之前为啥这么写 我也不知道
        if (this.showInvoiceType) return
        this.type = '2'
        /**  const res = pickBy(v, identity)
        const k = ['regAddress', 'linkTel', 'regBank', 'bankNo']
       if (k.some((key) => res[key])) {
          this.type = '2'
        } else {
          this.type = '1'
          this.$refs.form?.clearValidate(k)
        }*/
      },
      deep: true,
    },
  },
  data() {
    const validatorBankNo = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入银行账号'))
      }
      var judgeFn = new RegExp(/\s+/g);
      if (judgeFn.test(value)) {
          callback(new Error('银行账号不可以包含空格'))
        }
      callback()
    }
    return {
      dialogVisible: false,
      isShowSpecialTicket: true,
      rules: {
        invoiceType: { required: true, message: '请选择发票类型' },
        invoiceTitle: [
          { required: true, message: '请输入单位名称', trigger: 'change' },
        ],
        taxNumber: [
          { required: true, validator: bidderTaxID, trigger: 'blur' },
        ],
        regAddress: [
          { required: true, message: '请输入单位地址', trigger: 'blur' },
        ],
        linkTel: [
          { required: true, message: '请输入电话号码', trigger: 'blur' },
        ],
        regBank: [{ required: true, message: '请输入开户银行', trigger: 'blur' }],
        bankNo: [
          { required: true, validator: validatorBankNo, trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入电子邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
        postMobilePhone: {
          required: true,
          message: '请输入收件人联系方式',
          trigger: 'blur',
        },
        postAddress: {
          required: true,
          message: '请输入收件人联系地址',
          trigger: 'blur',
        },
      },
      type: '1',
      form: {
        invoiceType: '30',
        companyName: '',
        dutyParagraph: '',
        regAddress: '',
        linkTel: '',
        taxNumber: '',
      },
      restaurants: [],
    }
  },
  methods: {
    init(v) {
      this.form  =v
    },
    handleTypeChange(v) {
      if (v === '20') {
        this.type = '2'
      } else {
        this.type = '1'
      }
    },
    saveInvoiceForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form)
        }
      })
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.invoiceTitle
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    handleSelect(item) {
      this.$set(this.form, 'invoiceTitle', item.invoiceTitle)
      this.$set(this.form, 'taxNumber', item.taxNumber)
      this.$set(this.form, 'regAddress', item.regAddress)
      this.$set(this.form, 'linkTel', item.linkTel)
      this.$set(this.form, 'regBank', item.regBank)
      this.$set(this.form, 'bankNo', item.bankNo)
    },
  },
}
</script>

<style scoped>
.types {
  float: left;
  margin-left: 50px;
  margin-bottom: 20px;
}
.el-viewform {
  padding: 30px;
}
.my-autocomplete {
  line-height: normal;
  padding: 7px;
}
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}

.highlighted .addr {
  color: #ddd;
}
</style>
